import React, { useEffect } from 'react';
import { Typography, Card, Divider } from 'antd';
import { useTranslation } from 'react-i18next';

const { Title, Paragraph } = Typography;

const Privacy = ({ analytics }) => {
    const { i18n } = useTranslation();
    const isRu = i18n.language === 'ru';

    useEffect(() => {
        analytics();
    }, [analytics]);

    return (
        <div style={{ padding: '40px 20px', maxWidth: '800px', margin: '0 auto' }}>
            <Card style={{ borderRadius: '12px', boxShadow: '0 4px 12px rgba(0,0,0,0.05)' }}>
                <Title level={2} style={{ textAlign: 'center' }}>
                    {isRu ? 'Политика конфиденциальности' : 'Գաղտնիության քաղաքականություն'}
                </Title>
                <Divider />
                <Paragraph style={{ fontSize: '16px', lineHeight: '1.8' }}>
                    {isRu
                        ? 'AvtoDas уважает вашу конфиденциальность. Наш сайт не собирает личные данные пользователей, за исключением случаев, когда вы добровольно предоставляете их (например, в комментариях).'
                        : 'AvtoDas-ը հարգում է ձեր գաղտնիությունը: Մեր կայքը չի հավաքում անձնական տվյալներ, բացառությամբ այն դեպքերի, երբ դուք կամավոր տրամադրում եք դրանք։'
                    }
                </Paragraph>
                <Paragraph style={{ fontSize: '16px', lineHeight: '1.8' }}>
                    {isRu
                        ? 'Мы используем Google Analytics для анализа посещаемости сайта. Это помогает нам улучшать наш сервис для вас.'
                        : 'Մենք օգտագործում ենք Google Analytics՝ կայքի այցելությունները վերլուծելու համար: Դա օգնում է մեզ բարելավել մեր ծառայությունները ձեզ համար:'
                    }
                </Paragraph>
                <Paragraph style={{ fontSize: '16px', lineHeight: '1.8' }}>
                    {isRu
                        ? 'Если у вас есть вопросы, вы можете связаться с нами по адресу info@avtodas.am.'
                        : 'Եթե ունեք հարցեր, կարող եք կապվել մեզ հետ info@avtodas.am հասցեով։'
                    }
                </Paragraph>
            </Card>
        </div>
    );
};

export default Privacy;
